import { gql } from '@apollo/client/core';

export const UPDATE_ADVENTURE = gql`
  mutation updateAdventure($input: UpdateAdventureInput!, $updateAdventureId: Int) {
    updateAdventure(input: $input, id: $updateAdventureId) {
      adventure {
        status
      }
      problems {
        field
        message
      }
    }
  }
`;

export const UPDATE_SITTER_PROFILE = gql`
  mutation updateSitterProfile($input: UpdateSitterProfileInput!) {
    updateSitterProfile(input: $input) {
      sitterProfile {
        sitterAvailability {
          friday
          monday
          saturday
          sunday
          thursday
          tuesday
          wednesday
        }
      }
    }
  }
`;

export const CREATE_DRAFT_ADVENTURE = gql`
  mutation createDraftAdventure($input: CreateAdventureInput!) {
    createDraftAdventure(input: $input) {
      adventure {
        id
        title
        description
        sitterPassion
        surcharge
        adventureCategoryId
        adventureCategoryImage {
          adventureCategoryId
          id
          label
          url
        }
        ageRangeText
        duration
        adventureParentSupplies {
          item
        }
        adventureSitterSupplies {
          item
        }
        sitterAvailability {
          sunday
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
        }
      }
    }
  }
`;

export const UPDATE_DRAFT_ADVENTURE = gql`
  mutation updateDraftAdventure($id: Int!, $input: UpdateAdventureInput!) {
    updateDraftAdventure(id: $id, input: $input) {
      adventure {
        title
        description
        sitterPassion
        surcharge
        adventureCategoryId
        adventureCategoryImage {
          adventureCategoryId
          id
          label
          url
        }
        ageRangeText
        duration
        adventureParentSupplies {
          item
        }
        adventureSitterSupplies {
          item
        }
        sitterAvailability {
          sunday
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
        }
      }
    }
  }
`;

export default {
  UPDATE_ADVENTURE,
  UPDATE_SITTER_PROFILE,
};
